import Vue from 'vue'

Vue.directive('canAccess', {
  bind: function (el, binding, vnode) {
    try{
      if(binding.value){
        // replace HTMLElement with comment node
        const comment = document.createComment('');
        Object.defineProperty(comment, 'setAttribute', {
          value: () => undefined,
        });
        vnode.elm = comment;
        vnode.text = '';
        vnode.isComment = true;
        vnode.context = undefined;
        vnode.tag = undefined;
        vnode.data.directives = undefined;

        if (vnode.componentInstance) {
          vnode.componentInstance.$el = comment;
        }

        if (el.parentNode) {
          el.parentNode.replaceChild(comment, el);
        }
      }
    }catch(e){
    }
  }
});
